import { apmAsyncScope, knownFields, transactionTypes } from "./utils";

const log = apmAsyncScope.scope("filters");
const dropByFilterLog = log.scope("drop");
const enrichErrorsLog = log.scope("enrichErrors");

/*                               */
const isArray = <T>(v: unknown): v is T[] => Array.isArray(v);

/*                              */
const logFormatPayloadInfo = (p: Payload): string[] =>
  knownFields.map((f) => `${f}: ${p[f]?.length ?? 0}`);

type APMTransactionPayload = {
  name?: string;

  sampled?: boolean;

  span_count?: { started: number };

  spans?: unknown[];

  type: string;
};

type APMErrorPayload = {
  context?: {
    tags?: Labels;
  };
  exception?: {
    stacktrace?: {
      abs_path?: string;
      filename?: string;
    }[];
  };
};

export const transactionFilters: ((transaction: APMTransactionPayload) => boolean)[] = [
  (t) => !!t.sampled,
  (t) => {
    /*                                                           */
    if (t.type !== "http-request" || !t.name) return true;
    /*                                                         */
    if (!/https?:\/\/*                          */
    /*                                                         */
    return /otto.de\/*                                                     */
  },
];

/**
 *
 *
 *
 *
 *
 *
 */
export const dropTransactionsByFilter: FilterFn = (payload) => {
  const ttt = payload[knownFields[0]];
  dropByFilterLog.info("before processing", logFormatPayloadInfo(payload));

  /*                                */
  if (!isArray<APMTransactionPayload>(ttt)) return payload;

  /*                                                  */
  /*                                       */
  if (dropByFilterLog.isEnabled()) {
    ttt.forEach((t, i) => {
      dropByFilterLog.debug("transaction", i, "json:", JSON.stringify(t));
    });
  }

  /*                                                           */
  payload.transactions = ttt.filter((t) => transactionFilters.every((f) => f(t)));

  dropByFilterLog.info("after processing", logFormatPayloadInfo(payload));
  return payload;
};

export const isUnsampledTransaction = function (this: boolean, t: APMTransactionPayload): boolean {
  return !this && t.type === transactionTypes[0];
};

export const dropSpanDataFromTransaction: (t: APMTransactionPayload) => void = (t) => {
  t.sampled = false;
  t.span_count = { started: 0 };
  t.spans = [];
};

export const dropSpanDataFromUnsampledPageload: (pageloadActve: boolean) => FilterFn =
  (pageloadActve) => (payload) => {
    /*                                */
    const ttt = payload[knownFields[0]];

    /*                                */
    if (!isArray<APMTransactionPayload>(ttt)) return payload;

    ttt
      /*                                                       */
      .filter(isUnsampledTransaction, pageloadActve)
      /*                                                          */
      .forEach(dropSpanDataFromTransaction);

    return payload;
  };

/**
 *
 *
 */
export const enrichErrors: FilterFn = (payload) => {
  const eee = payload[knownFields[1]];
  if (!isArray<APMErrorPayload>(eee) || eee.length < 1) return payload;

  enrichErrorsLog.info("Enriching errors in payload", eee);
  eee.forEach((e) => {
    enrichErrorsLog.debug("Anaylzing error", e);
    const stack = e.exception?.stacktrace;
    if (!isArray(stack) || stack.length < 1) return;

    const labels = new Map<string, Set<string>>();

    stack.forEach((frame) => {
      const path = frame.filename ?? frame.abs_path;
      if (typeof path !== "string" || path.length < 1) return;

      const file = path.split("/").pop();
      if (typeof file !== "string" || file.length < 1) return;

      const [team, service, bundle] = file.split(".");
      if (!team || !service || !bundle) return;

      if (!labels.has(team)) labels.set(team, new Set());
      labels.get(team)!.add(`${service}.${bundle}`);
    });

    labels.forEach((v, k) => {
      e.context ??= {};
      e.context.tags ??= {};
      e.context.tags[`${k}_error`] = [...v].join(", ");
    });
  });

  enrichErrorsLog.info("Finished enriching errors in payload", eee);
  return payload;
};
